module.exports = __webpack_public_path__ + "assets/avatar_coupe.c9019562.svg";